import _ from 'underscore';
import { useState, useCallback } from 'react';

const dashboardPreferencesName = 'dashboard/preferences';

export const useDashboardPreferences = ({ preference, navigationLevel }) => {
  const dashboardPreferences = preference.findByNameAtAccountLevel(dashboardPreferencesName);
  const dashboardId = `default-${navigationLevel}`;
  const [options, setOptions] = useState(_.get(dashboardPreferences, ['Data', dashboardId, 'options'], {}));
  const saveDashBoardOptions = useCallback((newOptions) => {
    preference.setAtAccountLevel({
      Name: dashboardPreferencesName,
      Data: {
        ...dashboardPreferences?.Data,
        [dashboardId]: {
          cards: _.get(dashboardPreferences, ['Data', dashboardId, 'cards']),
          options: _.extend({}, options, newOptions),
        },
      },
    });
    setOptions(newOptions);
  }, [dashboardId, dashboardPreferences, options, preference]);

  return {
    options,
    saveDashBoardOptions,
  };
};
